import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { TableCompHead } from '../../../../components/ui';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={12}
        rowSpan={2}
        labels={['Doc No', 'Date']}
        values={[
          'TCS/PDQA',
          isView ? (
            formatDate(moduleData.pir_date)
          ) : (
            <DatePickerMui
              label="PIR"
              value={moment(moduleData.pir_date)}
              onChange={(date) => {
                moduleData.pir_date = date;
                setRender((prev) => !prev);
              }}
              sx={{ width: '150px' }}
            />
          ),
        ]}
        heading="PIR PQCC REPORT"
      />
      <tr>
        <th colSpan={10} rowSpan={2}>
          CUSTOMER NAME:-
          {moduleData.customer_name
            ? moduleData.customer_name
            : moduleData.customer_id?.customer_name}
        </th>
        <th colSpan={2} align="left">
          INVOICE NO:-{' '}
          <TableInput
            name="invoice_no"
            type="text"
            value={moduleData.invoice_no}
            onChange={(e) => {
              moduleData.invoice_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2}>
          <TableInput
            name="batch_qty"
            type="number"
            value={moduleData.batch_qty ?? null}
            onChange={(e) => {
              moduleData.batch_qty = +e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2}>PRODUCT</th>
        <th colSpan={2}> PART NAME </th>
        <th colSpan={3}> CUSTOMER PART NO</th>
        <th colSpan={3}>DOC. ISSUE NO:-01</th>
        <th colSpan={2} rowSpan={2}>
          QTY./BOX:{' '}
          <TableInput
            name="qty_per_box"
            type="number"
            value={moduleData.qty_per_box}
            onChange={(e) => {
              moduleData.qty_per_box = +e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2}>
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th colSpan={2}>
          {moduleData.part_name
            ? moduleData.part_name
            : moduleData.part_id?.part_name}
        </th>
        <th colSpan={3}>
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th colSpan={3}>DRG.REV.NO:- 05</th>
      </tr>
      <tr>
        {['S.No', 'INSP. ITEM', 'SPECIFICATIONS', 'METHOD'].map((head) => (
          <th rowSpan={2} style={{ textTransform: 'uppercase' }}>
            {head}
          </th>
        ))}
        <th colSpan={6} style={{ textTransform: 'uppercase' }}>
          OBSERVED DIMENSIONS
        </th>
        <th style={{ textTransform: 'uppercase' }} rowSpan={2} colSpan={2}>
          REMARKS
        </th>
      </tr>
      <tr>
        {Array.from({ length: 5 }, (_, index) => (
          <th style={{ width: '90px' }} key={index + 'Heading'}>
            {index + 1}
          </th>
        ))}
        <th style={{ textTransform: 'uppercase' }}>Status</th>
      </tr>
    </thead>
  );
};

export default THead;
